import React from 'react';
import { Link } from 'react-router-dom';
import MainNav from '@/components/MainNav';
import AccessibilityWidget from '@/components/AccessibilityWidget';
import PricingCard from '@/components/PricingCard';
import Footer from '@/components/Footer';

const PricingPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-secondary/20">
      <AccessibilityWidget />
      <header>
        <MainNav currentPath="pricing" />
      </header>

      <main className="container max-w-6xl mx-auto px-4 py-12">
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold tracking-tight mb-4">
            Simple, Transparent Pricing
          </h1>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Make your website accessible to everyone with our affordable plans
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 place-content-center place-items-center">
          <PricingCard
            title="Standard Plan"
            description="Perfect for a single website"
            monthlyPrice={1.99}
            yearlyPrice={19.99}
            maxInstallations={1}
            features={[
              'Single website installation',
              'Full accessibility widget',
              'Voice navigation',
              'Customizable settings',
              'Analytics dashboard',
              'Email support',
              '99.9% uptime guarantee'
            ]}
          />
          
          <PricingCard
            title="Pro Plan"
            description="For businesses with multiple websites"
            monthlyPrice={9.99}
            yearlyPrice={99.99}
            maxInstallations={999999}
            features={[
              'Unlimited website installations',
              'Full accessibility widget',
              'Voice navigation',
              'Customizable settings',
              'Advanced analytics',
              'Priority email support',
              'Dedicated account manager',
              '99.99% uptime guarantee'
            ]}
          />
        </div>

        <div className="mt-16 text-center">
          <h2 className="text-2xl font-bold mb-4">Frequently Asked Questions</h2>
          <div className="max-w-2xl mx-auto space-y-6 text-left">
            <div>
              <h3 className="font-medium mb-2">How does the pricing work?</h3>
              <p className="text-muted-foreground">
                Our pricing is per website installation. The Standard Plan allows one installation, while the Pro Plan offers unlimited installations.
              </p>
            </div>
            <div>
              <h3 className="font-medium mb-2">Can I modify the widget settings?</h3>
              <p className="text-muted-foreground">
                Yes, you can customize the widget's appearance, position, and features through your account dashboard.
              </p>
            </div>
            <div>
              <h3 className="font-medium mb-2">Is there a free trial?</h3>
              <p className="text-muted-foreground">
                You can try our demo to see how the widget works. Our pricing is affordable to make accessibility available to everyone.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PricingPage;
